/** Filter groups for a Standard Report: Determines where the filter input component should be placed. */
export enum ReportFilterGroupEnum {
  /** Filter is analytics criteria tab */
  ANALYTICS_TAB = 'ANALYTICS_TAB',
  /** Filter is sub-total criteria tab */
  SUBTOTAL_TAB = 'SUBTOTAL_TAB',
  /** Filter is plot criteria tab */
  PLOT_TAB = 'PLOT_TAB',
  /** Filter is search query to input at top right search input */
  SEARCH_QUERY = 'SEARCH_QUERY',
  /** Panel above subtotals */
  TOP_PANEL = 'TOP_PANEL',
  /** Sidebar on the right */
  SIDE_BAR = 'SIDE_BAR',
  /** Filter is group radiobutton */
  GROUP_BY_TAB = 'GROUP_BY_TAB',
  /** Pagination limit value */
  PAGINATION_LIMIT = 'PAGINATION_LIMIT',
  /** Pagination offset value */
  PAGINATION_OFFSET = 'PAGINATION_OFFSET',
  /** Items sub-API columns selection component */
  ITEM_COLUMNS_SELECT = 'ITEM_COLUMNS_SELECT',
  /** Sorting expression */
  SORTING_EXPRESSION = 'SORTING_EXPRESSION',
}
